import ResourceService from './resource.service'

class RegionService extends ResourceService {
  static get resource() {
    return 'region'
  }
}

export default RegionService
